import { render, staticRenderFns } from "./VEmployerCompanySponsorLicence.vue?vue&type=template&id=1bd8aba6&scoped=true&lang=pug"
import script from "./VEmployerCompanySponsorLicence.vue?vue&type=script&lang=ts"
export * from "./VEmployerCompanySponsorLicence.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerCompanySponsorLicence.vue?vue&type=style&index=0&id=1bd8aba6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd8aba6",
  null
  
)

export default component.exports